const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const updateAllowedIpApi = async (id, ipData) => {
  const token = localStorage.getItem('token');

  if (!token) {
    console.error('[updateAllowedIpApi] Ошибка: Токен авторизации не найден.');
    throw new Error('Токен авторизации не найден.');
  }

  try {
    const response = await fetch(`${API_BASE_URL}/admin/user/allowed-ips/${id}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(ipData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('[updateAllowedIpApi] Ошибка при обновлении IP:', errorData);
      
      throw { ...errorData, statusCode: response.status };
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('[updateAllowedIpApi] Ошибка сети или другая ошибка при обновлении IP:', error);
    throw error;
  }
};